import type { MessageDescriptor } from 'react-intl';
import { watermarkChoiceMessages as messages } from './watermarkChoiceMessages';
import type { WatermarkChoiceSurface } from './watermarkChoiceStore';

interface ChoiceCopy {
  /** The first row: the clean file. */
  clean: MessageDescriptor;
  /** The second row: go on with the watermark. */
  keep: MessageDescriptor;
  /** The link of the second row. */
  keepAction: MessageDescriptor;
}

/** The words of each use of the choice (design: trial-upsell a2). */
export const CHOICE_COPY: Record<WatermarkChoiceSurface, ChoiceCopy> = {
  download: { clean: messages.cleanDownload, keep: messages.keepDownload, keepAction: messages.keepActionDownload },
  share: { clean: messages.cleanShare, keep: messages.keepShare, keepAction: messages.keepActionShare },
  post: { clean: messages.cleanPost, keep: messages.keepPost, keepAction: messages.keepActionPost },
  zip: { clean: messages.cleanZip, keep: messages.keepZip, keepAction: messages.keepActionZip },
};
